export default __webpack_public_path__ + "static/media/Flag_of_Papua_New_Guinea.3779e231.svg";